/**
 * DevExtreme (esm/__internal/grids/new/grid_core/data_controller/store_load_adapter/store_load_adapter.js)
 * Version: 25.1.4
 * Build date: Tue Aug 05 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import {
    Deferred
} from "../../../../../../core/utils/deferred";
import {
    deferredCache
} from "../deferred_cache";
import {
    getLocalLoadOptions,
    getStoreLoadOptions
} from "../utils";
export class StoreLoadAdapter {
    constructor(dataSourceReactive, localLoadOptionsReactive, localStoreFabric) {
        this.dataSourceReactive = dataSourceReactive;
        this.localLoadOptionsReactive = localLoadOptionsReactive;
        this.localStoreFabric = localStoreFabric;
        this.loadFromStore = deferredCache((loadOptions => {
            const dataSource = this.dataSourceReactive.peek();
            return dataSource.store().load(loadOptions)
        }))
    }
    load() {
        let loadOptions = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
        const result = Deferred();
        const {
            localOptions: localOptions,
            remoteOptions: remoteOptions
        } = this.getLoadOptions(loadOptions);
        this.loadFromStore(remoteOptions).done((loadedData => {
            const localStore = this.localStoreFabric(loadedData);
            localStore.load(localOptions).done((processedData => {
                result.resolve(processedData)
            })).fail(result.reject)
        })).fail(result.reject);
        return result
    }
    getLocalLoadOperations() {
        return this.localLoadOptionsReactive.peek()
    }
    getLoadOptions(loadOptions) {
        const localLoadOptions = this.localLoadOptionsReactive.peek();
        const localOptions = getLocalLoadOptions(loadOptions, localLoadOptions);
        const remoteOptions = getStoreLoadOptions(loadOptions, localLoadOptions);
        return {
            localOptions: localOptions,
            remoteOptions: remoteOptions
        }
    }
}
